import { ark, HTMLArkProps } from "@ark-ui/react/factory";
import { mergeProps } from "@zag-js/react";

import dialogStyles from "@/features/widget-forms/forms/weather-model-map/weather-model-map-dialog.module.css";

export function Root(props: HTMLArkProps<"form">) {
  return <ark.form {...mergeProps({ className: dialogStyles.panelGrid }, props)} />;
}

export function Header(props: HTMLArkProps<"div">) {
  return <ark.div {...mergeProps({ className: dialogStyles.header }, props)} />;
}

export function Nav(props: HTMLArkProps<"div">) {
  return <ark.div {...mergeProps({ className: dialogStyles.nav }, props)} />;
}

export function Settings(props: HTMLArkProps<"div">) {
  return <ark.div {...mergeProps({ className: dialogStyles.settings }, props)} />;
}

export function Preview(props: HTMLArkProps<"div">) {
  return <ark.div {...mergeProps({ className: dialogStyles.preview }, props)} />;
}

export function Footer(props: HTMLArkProps<"div">) {
  return <ark.div {...mergeProps({ className: dialogStyles.footer }, props)} />;
}
